// @flow
import React, { Component } from "react"
import { connect } from "react-redux"
import { SubmissionError } from "redux-form"
import { Helmet } from "react-helmet"
import { Motion, spring, presets } from "react-motion"
import { push, replace } from "react-router-redux"
import {
  Modal,
  Content,
  Body,
  Header,
  Footer,
  Trailing,
  PrimaryHeading,
  SubHeading,
  TrailingHeading,
  FooterLink
} from "../UI/Modal"
import Loader from "../UI/Loader"
import { InfoButton } from "../UI/Buttons"
import { loginUser } from "../Auth"
import LoginForm from "./LoginForm"

type AuthValues = {
  email: string,
  password: string
}

type Props = {
  push: Function,
  replace: Function
}

type State = {
  loading: boolean
}

class Login extends Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  async handleSubmit(values: AuthValues) {
    const { replace } = this.props
    this.setState(() => ({ loading: true }))
    let json = null
    try {
      json = await loginUser(values.email, values.password)
    } catch (error) {
      this.setState(() => ({ loading: false }))
      throw new SubmissionError({
        _error: "Could not connect."
      })
    }
    if (json.errors && json.errors.state) {
      this.setState(() => ({ loading: false }))
      throw new SubmissionError({
        _error: json.errors.state[""],
        ...json.errors.state
      })
    }
    replace("/admin")
  }

  render() {
    const { push } = this.props
    const { loading } = this.state

    return (
      <Modal>
        <Helmet>
          <title>Login</title>
        </Helmet>
        <Motion
          key="body"
          defaultStyle={{ y: -100, a: 0 }}
          style={{
            y: spring(0, presets.wobbly),
            a: spring(1, presets.noWobble)
          }}
        >
          {is => (
            <Body
              style={{
                transform: `translate(0, ${is.y}px`,
                opacity: is.a
              }}
            >
              <Loader loading={loading}>
                <Header>
                  <PrimaryHeading>Kiosk Admin</PrimaryHeading>
                  <SubHeading>Account Login</SubHeading>
                </Header>
                <Content>
                  <LoginForm
                    onSubmit={(values: AuthValues) => this.handleSubmit(values)}
                  />
                </Content>
                <Footer>
                  <FooterLink to="/auth/forgot">
                    Forgot Your Password?
                  </FooterLink>
                </Footer>
              </Loader>
            </Body>
          )}
        </Motion>
        <Motion
          key="trailing"
          defaultStyle={{ a: 0 }}
          style={{
            a: spring(loading ? 0 : 1, presets.noWobble)
          }}
        >
          {is => (
            <Trailing style={{ opacity: is.a }}>
              <TrailingHeading>Don't have an account yet?</TrailingHeading>
              <InfoButton
                block={true}
                outline={true}
                onClick={() => push("/auth/sign-up")}
              >
                Create an Account
              </InfoButton>
            </Trailing>
          )}
        </Motion>
      </Modal>
    )
  }
}

export default connect(null, { push, replace })(Login)



// WEBPACK FOOTER //
// ./src/PublicArea/Login.js